var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vote-option"},[(_vm.iconUrl)?_c('img',{staticClass:"vote-icon",attrs:{"src":_vm.iconUrl}}):_vm._e(),_c('div',{class:_vm.descriptionClassName},[_vm._v(" "+_vm._s(_vm.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }